import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheese,
  faCheckCircle,
  faArrowUp,
  faArrowDown
} from "@fortawesome/free-solid-svg-icons";

const ReadyProductsOverview = ({ products = [], loading = false }) => {
  if (loading) {
    return <div className="text-center p-3 text-xs">Carregando...</div>;
  }

  // Garantir que products é um array
  const productsArray = Array.isArray(products) ? products : [];

  if (!productsArray.length) {
    return (
      <div className="bg-white p-3 rounded-lg shadow">
        <h3 className="text-xs font-semibold mb-2 flex items-center">
          <FontAwesomeIcon icon={faCheese} className="mr-2 text-yellow-600" size="sm" />
          Stock Pronto
        </h3>
        <p className="text-xs text-neutral-500">Nenhum produto.</p>
      </div>
    );
  }

  const getStockStatusConfig = (status) => {
    switch(status) {
      case 'LOW_STOCK': 
        return { 
          icon: faArrowDown, 
          color: 'text-red-600', 
          bg: 'bg-red-100', 
          text: 'text-red-800',
          label: 'Baixo'
        };
      case 'EXCESS_STOCK': 
        return { 
          icon: faArrowUp, 
          color: 'text-purple-600', 
          bg: 'bg-purple-100', 
          text: 'text-purple-800',
          label: 'Excesso'
        };
      default: 
        return { 
          icon: faCheckCircle, 
          color: 'text-green-600', 
          bg: 'bg-green-100', 
          text: 'text-green-800',
          label: 'Normal'
        };
    }
  };

  return (
    <div className="bg-white p-3 rounded-lg shadow flex flex-col max-h-[320px]">
      <h3 className="text-xs font-semibold mb-2 flex items-center flex-shrink-0">
        <FontAwesomeIcon icon={faCheese} className="mr-2 text-yellow-600" size="sm" />
        Stock Pronto
      </h3>
      <div className="space-y-1 overflow-y-auto flex-1 min-h-0">
        {productsArray.slice(0, 10).map((product) => {
          const statusConfig = getStockStatusConfig(product.stock_status);
          return (
            <div key={product.id} className="flex items-center justify-between p-1.5 bg-neutral-50 rounded text-xs">
              <div className="flex items-center space-x-2 flex-1 min-w-0">
                <FontAwesomeIcon icon={statusConfig.icon} className={statusConfig.color} size="sm" />
                <div className="min-w-0 flex-1">
                  <p className="font-medium text-xs truncate">{product.name}</p>
                  <p className="text-xs text-neutral-500 truncate">
                    {product.current_stock_kg}kg
                    {product.available_lots_count > 0 && ` (${product.available_lots_count}L)`}
                  </p>
                </div>
              </div>
              <div className="text-right ml-1 flex-shrink-0">
                <span className={`px-1 py-0 rounded text-xs whitespace-nowrap ${statusConfig.bg} ${statusConfig.text}`}>
                  {statusConfig.label}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ReadyProductsOverview;